import api from "../api/flexapi";

// Type of action being performed
export const userProfileLoadBegin = "USER_PROFILE_LOAD_BEGIN";
export const userProfileLoadSuccess = "USER_PROFILE_LOAD_SUCCESS";
export const userProfileLoadFailed = "USER_PROFILE_LOAD_FAILED";

// Call API to load module data
export const load = function load() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: userProfileLoadBegin, payload: null });

    api
      .getUserProfile()
      .then(response => {
        dispatch({ type: userProfileLoadSuccess, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: userProfileLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
};

// Update Profile
export const userProfileUpdateBegin = "USER_PROFILE_UPDATE_BEGIN";
export const userProfileUpdateSuccess = "USER_PROFILE_UPDATE_SUCCESS";
export const userProfileUpdateFailed = "USER_PROFILE_UPDATE_FAILED";

export const update = (data, employeeKey) => dispatch => {
  dispatch({ type: userProfileUpdateBegin, payload: null });

  const updateData = [];
  Object.keys(data).forEach(key => {
    updateData.push({ Id: key, Value: data[key] });
  });

  api
    .updateUserProfile({ employeeKey, data: updateData })
    .then(response => {
      const data = [];
      response.body.Data.forEach(item => {
        data.push({ id: item.Id, value: item.Value });
      });
      response.body.Data = data;

      dispatch({ type: userProfileUpdateSuccess, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: userProfileUpdateFailed,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/userProfileActions.jsx